import script from "./WeatherWidgetMixin.vue?vue&type=script&lang=js"
export * from "./WeatherWidgetMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__